
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";

interface EmptyAgentStateProps {
  onCreateNew: () => void;
}

export const EmptyAgentState = ({ onCreateNew }: EmptyAgentStateProps) => {
  return (
    <div className="flex flex-col items-center justify-center p-8 border rounded-md bg-muted/10">
      <p className="text-muted-foreground mb-4">No ElevenLabs agents found.</p>
      <Button onClick={onCreateNew}>
        <Plus className="h-4 w-4 mr-2" />
        Create Agent
      </Button>
    </div>
  );
};
